import {Component, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {QuestionComponent} from '../question.component';
import {QuestionBase} from '../../domain/question.base';
import {ScrollService} from '../scroll.service';

@Component({
  selector: `crds-question-toggle`,
  template: `
    <div *ngIf="show" [formGroup]="form" class="form-group form-inline">
      <label *ngIf="question.label" class="form-label" [attr.for]="question.key">{{question.label}}
        <span *ngIf="question.required"> *</span>
        <crds-form-error *ngIf="isInvalid" [question]="question"
                         [message]="question.errorMessage"></crds-form-error>
      </label>
      <label class="switch">
        <input [id]="question.key"
               type="checkbox"
               [formControlName]="question.key"
               #toggleInput>
        <span class="slider round"></span>
        <span class="toggleValueUserDisplay"></span>
      </label>
      <span>{{form.get(question.key).value ? 'Yes' : 'No'}}</span>

      <!-- QUESTION HINT -->
      <crds-question-hint [question]="question"></crds-question-hint>
    </div>`
})
export class ToggleQuestionComponent extends QuestionComponent implements OnInit {
  @Input() form;
  @Input() question: QuestionBase<any>;
  @ViewChild('toggleInput') input;
  type: string;

  constructor(private renderer: Renderer2,
              private scrollService: ScrollService) {
    super();
  }

  ngOnInit(): void {
    this.scrollService.scrollObservable
      .subscribe((documentId) => {
        if (documentId === this.question.key) {
          this.input.nativeElement.scrollIntoView();
        }
      });
  }

  get isInvalid() {
    return this.form.get(this.question.key).touched && this.form.get(this.question.key).invalid;
  }

  get show() {
    const showIfQuestionPopulated = this.question.showIf ?
      this.showIf :
      true;
    return (this.question.showIfPopulated !== true || (this.value)) &&
      showIfQuestionPopulated && this.question.show !== false;
  }
}
